import React from 'react';
import { useParams } from 'react-router';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, List, ListSubheader } from '@material-ui/core';
import ConversationListItem from './ConversationListItem';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white
  },
  searchInput: {
    flexGrow: 1
  }
}));

function ConversationList({ conversations, className }) {
  const classes = useStyles();
  const params = useParams();
  const selectedConversation = params.id;
  return (
    <div
      className={clsx(classes.root, className)}
    >
      <Divider />
      <List disablePadding subheader={
        <ListSubheader>
          Yorumlar
          <Divider />
        </ListSubheader>
      }>
        {conversations.map((conversation, i) => (
          <ConversationListItem
            active={conversation.id === selectedConversation}
            conversation={conversation}
            divider={i < conversations?.length - 1}
            key={conversation.id}
          />
        ))}
      </List>
    </div>
  );
}

ConversationList.propTypes = {
  className: PropTypes.string,
  conversations: PropTypes.array.isRequired
};

export default ConversationList;
